import medicalPlan from './medicalPlan';

const routes = [
  {
    path: 'student',
    component: () => import('@/views/student/Wrapper.vue'),
    children: [...medicalPlan],
  },
];

export default routes;
